const TechnologyNames = require('./Names/TechnologyNames');
const TechnologyTypes = require('./TechnologyTypes');
const {CivilCardTypes, MilitaryCardTypes, CardDeck} = require('./Names/CardTypes');

const Age = {
    AgeA: "Age A",
    Age1: "Age I",
    Age2: "Age II",
    Age3: "Age III",
    Age4: "Age IV"
}

// Ages from earliest to latest, for comparing card levels
const AgeOrder = [Age.AgeA, Age.Age1, Age.Age2, Age.Age3, Age.Age4];

module.exports = {
    Age,
    AgeOrder,
    TechnologyNames,
    TechnologyTypes,
    CardDeck,
    CivilCardTypes,
    MilitaryCardTypes,
}